import { type CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const HeimkaupConfig: CompanyConfig = {
  id: '8b4b64e1-0e88-4889-b75a-1367bfb9baea',
  lang: 'is',
  langs: ['is', 'en', 'pl'],
  name: 'Heimkaup',
  nameSecondary: 'Heimkaup',
  currency: '',
  currencyCode: 'ISK',
  officialName: 'Heimkaup',
  email: 'Heimkaup@heimkaup.is',
  contactEmail: 'Heimkaup@heimkaup.is',
  feedbackEmail: 'Heimkaup@heimkaup.is',
  phonePlaceholder: '+354',
  defaultPhoneCode: '+354',
  phoneNumber: '+354 4336000',
  ageRestricted: 20,
  timeZone: 'Atlantic/Reykjavik',
  minimalOrderFeeThreshold: 700,
  address: 'Þönglabakki 1, 109 Reykjavík, Iceland',
  canonical: '',
  defaultVolumeDisplay: '1x',
  availablePaymentMethods: ['verifone'],
  workingHours: {
    start: '11:00',
    end: '22:00',
  },
  warehouse: {
    default: 'H495',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 64.10861294045579,
      lng: -21.84256888908368,
    },
  },
  map: {
    center: { lat: 64.10861294045579, lng: -21.84256888908368 },
    zoom: 12,
  },
  paymentMethods: [],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    facebook: 'https://www.facebook.com/heimkaup/',
    instagram: 'https://www.instagram.com/heimkaup.is/',
    // tiktok: 'https://www.tiktok.com/@citydrinksuae/',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: '',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com/us/app/heimkaup/id6743180799',
    android: 'https://play.google.com/store/apps/details?id=com.heimkaup.app',
  },
  apis: {},
  countryCode: 'IS',
  useAutocompleteAddress: true,
  license: {
    name: 'Heimkaup',
    numberPrinary: '',
  },
};
